var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.45579 15.8363V9.39698L3.45875 7.57L1.66797 6.55615V14.6999C1.66797 15.3287 2.1774 15.8363 2.80434 15.8363H5.45579Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5469 15.8362H17.1983C17.8272 15.8362 18.3347 15.3268 18.3347 14.6999V6.55615L16.3063 7.71739L14.5469 9.39692V15.8362Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45533 9.39702L5.18359 6.88099L5.45533 4.4729L10.0007 7.88195L14.546 4.4729L14.85 6.75098L14.546 9.39702L10.0007 12.8061L5.45533 9.39702Z",
    fill: "#EA4335"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5469 4.47279V9.39692L18.3347 6.55609V5.04095C18.3347 3.6357 16.7306 2.83461 15.6075 3.67737L14.5469 4.47279Z",
    fill: "#FBBC04"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 6.55612L3.41006 7.86273L5.45579 9.39695V4.47282L4.39513 3.6774C3.27015 2.83457 1.66797 3.63573 1.66797 5.04091V6.55612Z",
    fill: "#C5221F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail24Px);
export default __webpack_public_path__ + "static/media/Gmail_24px.90350385247f9e946811c34f0940b284.svg";
export { ForwardRef as ReactComponent };